import { Modal } from 'antd';

import { texts } from '../constants/texts';
import { useNavigationBlocker } from '../../../hooks/useNavigationBlocker';

const { confirm } = Modal;

export const useFlatsGridPreviewNavigationBlocker = ({
  isBlocking,
  onOk,
  onCancel,
  beforeUnloadCallback,
  hasFlatsGrid,
}) => {
  const cancelTitle = hasFlatsGrid
    ? texts.flatsGridPreviewCancelEditConfiramtion
    : texts.flatsGridPreviewCancelCreateConfiramtion;
  useNavigationBlocker(
    isBlocking,
    ({ location, action, unblock, history }) => {
      confirm({
        title: cancelTitle,
        okText: texts.yes,
        cancelText: texts.no,
        onOk: () => onOk({ location, action, unblock, history }),
        onCancel,
      });
    },
    beforeUnloadCallback,
  );
};
